import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ConstructionIcon from '@mui/icons-material/Construction';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import PlumbingIcon from '@mui/icons-material/Plumbing';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import FormatPaintIcon from '@mui/icons-material/FormatPaint';
import CarpenterIcon from '@mui/icons-material/Carpenter';
import BathroomIcon from '@mui/icons-material/Bathroom';
import KitchenIcon from '@mui/icons-material/Kitchen';
import RoofingIcon from '@mui/icons-material/Roofing';
import LayersIcon from '@mui/icons-material/Layers';
import DoorFrontIcon from '@mui/icons-material/DoorFront';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import GroupsIcon from '@mui/icons-material/Groups';
import EngineeringIcon from '@mui/icons-material/Engineering';
import VerifiedIcon from '@mui/icons-material/Verified';
import HandshakeIcon from '@mui/icons-material/Handshake';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const iconMap = {
  HomeWork: HomeWorkIcon,
  Construction: ConstructionIcon,
  AutoFixHigh: AutoFixHighIcon,
  Architecture: ArchitectureIcon,
  Plumbing: PlumbingIcon,
  ElectricalServices: ElectricalServicesIcon,
  FormatPaint: FormatPaintIcon,
  Carpenter: CarpenterIcon,
  Bathroom: BathroomIcon,
  Kitchen: KitchenIcon,
  Roofing: RoofingIcon,
  Layers: LayersIcon,
  DoorFront: DoorFrontIcon,
  ViewQuilt: ViewQuiltIcon,
  Groups: GroupsIcon,
  Engineering: EngineeringIcon,
  Verified: VerifiedIcon,
  Handshake: HandshakeIcon,
  EmojiEvents: EmojiEventsIcon,
};

export function getIcon(name) {
  return iconMap[name] || ConstructionIcon;
}

export const iconOptions = Object.keys(iconMap).map((key) => ({
  value: key,
  label: key.replace(/([A-Z])/g, ' $1').trim(),
  Icon: iconMap[key],
}));

export default iconMap;
